import React from 'react';
import { useLocation } from 'react-router-dom';
import { Box, AppBar, Toolbar, Typography, Chip, CircularProgress } from '@mui/material';
import Sidebar from './Sidebar';
import { useHealthData } from '../utils/hooks';

const drawerWidth = 280;

function Layout({ children }) {
  const location = useLocation();
  const { healthData, loading } = useHealthData();

  const getPageTitle = () => {
    const path = location.pathname;
    switch (path) {
      case '/':
        return 'SE Tools Dashboard';
      case '/auth-token':
        return 'Auth Token - SE Tools Dashboard';
      case '/ask-pdf':
        return 'Ask PDF - SE Tools Dashboard';
      case '/download-pdfs':
        return 'Download PDFs - SE Tools Dashboard';
      case '/pdf-status':
        return 'PDF Status - SE Tools Dashboard';
      case '/list-pdfs':
        return 'List PDFs - SE Tools Dashboard';
      case '/health-check':
        return 'Health Check - SE Tools Dashboard';
      default:
        return 'SE Tools Dashboard';
    }
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'ok': return 'success';
      case 'fail': case 'error': return 'error';
      case 'degraded': return 'warning';
      default: return 'default';
    }
  };

  return (
    <Box sx={{ display: 'flex' }}>
      <AppBar
        position="fixed"
        sx={{
          width: `calc(100% - ${drawerWidth}px)`,
          ml: `${drawerWidth}px`,
        }}
      >
        <Toolbar>
          <Typography variant="h6" noWrap component="div">
            {getPageTitle()}
          </Typography>
          <Box sx={{ flexGrow: 1 }} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {loading ? (
              <CircularProgress size={16} color="inherit" />
            ) : (
              <Chip
                label={healthData?.overall || 'Unknown'}
                color={getStatusColor(healthData?.overall)}
                size="small"
                variant="outlined"
                sx={{ color: 'white', borderColor: 'white' }}
              />
            )}
          </Box>
        </Toolbar>
      </AppBar>
      
      <Sidebar />
      
      <Box
        component="main"
        sx={{ flexGrow: 1, bgcolor: 'background.default', p: 0 }}
      >
        <Toolbar />
        {children}
      </Box>
    </Box>
  );
}

export default Layout;
